const NOTIFICATIONS_STORAGE_KEY = 'afn-ally-notifications-enabled';
let serviceWorkerRegistrationPromise: Promise<ServiceWorkerRegistration | null> | null = null;

export function areNotificationsEnabled() {
  if (typeof window === 'undefined') return false;
  const stored = window.localStorage.getItem(NOTIFICATIONS_STORAGE_KEY);
  return stored === null ? true : stored === 'true';
}

export async function registerServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return null;
  }

  if (!serviceWorkerRegistrationPromise) {
    serviceWorkerRegistrationPromise = navigator.serviceWorker
      .register('/sw.js')
      .catch((error) => {
        console.warn('Service worker registration failed:', error);
        return null;
      });
  }

  return serviceWorkerRegistrationPromise;
}

export async function requestNotificationPermission(): Promise<boolean> {
  if (typeof window === 'undefined' || !('Notification' in window) || !areNotificationsEnabled()) {
    return false;
  }

  if (Notification.permission === 'granted') return true;
  const result = await Notification.requestPermission();
  return result === 'granted';
}

export function showNotification(title: string, body: string, icon?: string, config?: { force?: boolean }) {
  if (
    typeof window === 'undefined' ||
    typeof document === 'undefined' ||
    !('Notification' in window) ||
    !areNotificationsEnabled()
  ) {
    return;
  }

  if (Notification.permission !== 'granted') return;
  if (document.hasFocus() && !config?.force) return;

  const options: NotificationOptions = {
    body,
    icon: icon || '/ally-icon.png',
    tag: 'ally-message',
  };

  if ('serviceWorker' in navigator) {
    void navigator.serviceWorker.ready
      .then(async (registration) => {
        if (registration?.showNotification) {
          await registration.showNotification(title, options);
          return;
        }
        new Notification(title, options);
      })
      .catch(() => {
        new Notification(title, options);
      });
    return;
  }

  new Notification(title, options);
}

export async function primeNotifications() {
  if (
    typeof window === 'undefined' ||
    !('Notification' in window) ||
    !areNotificationsEnabled() ||
    Notification.permission !== 'default'
  ) {
    return;
  }

  try {
    await requestNotificationPermission();
  } catch (error) {
    console.warn('Notification permission request failed:', error);
  }
}

export function notifyNewMessage(title: string, body: string, tag?: string) {
  showNotification(title, body, '/ally-icon.png');
  return tag;
}
